module.exports = __webpack_public_path__ + "static/media/background-impericon.c4c5017c.jpg";